export const EXTERNAL_USER_TYPES = [
  "COOPERATING_PARTNER",
  "AGRICULTURE_EXTENSION_WORKER",
  "GOVERNMENT_STAKEHOLDER",
  "OTHER",
] as const;

export type ExternalUserType = (typeof EXTERNAL_USER_TYPES)[number];

export const EXTERNAL_USER_TYPE_LABEL_KEYS: Record<ExternalUserType, string> = {
  COOPERATING_PARTNER: "externalUserDetails.type.cooperatingPartner",
  AGRICULTURE_EXTENSION_WORKER: "externalUserDetails.type.agricultureExtensionWorker",
  GOVERNMENT_STAKEHOLDER: "externalUserDetails.type.governmentStakeholder",
  OTHER: "externalUserDetails.type.other",
};

export const GENERIC_ORGANIZATION_LABEL_KEY = "externalUserDetails.organizationLabel";

// Full sentences rather than "Name of " + a lowercased type: lowercasing a
// translated noun is not safe outside English. OTHER falls back to the generic
// label because "Name of Other" reads badly.
export const ORGANIZATION_LABEL_KEYS: Record<ExternalUserType, string> = {
  COOPERATING_PARTNER: "externalUserDetails.organizationLabelByType.cooperatingPartner",
  AGRICULTURE_EXTENSION_WORKER:
    "externalUserDetails.organizationLabelByType.agricultureExtensionWorker",
  GOVERNMENT_STAKEHOLDER: "externalUserDetails.organizationLabelByType.governmentStakeholder",
  OTHER: GENERIC_ORGANIZATION_LABEL_KEY,
};

export const isExternalUserType = (value: unknown): value is ExternalUserType =>
  EXTERNAL_USER_TYPES.includes(value as ExternalUserType);

export interface Country {
  id: number | string;
  name?: string;
  code?: string;
}

export interface Person {
  id?: number | string;
  uuid?: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
}

export interface ExternalUser {
  id: number | string;
  person?: Person;
  country?: Country;
  email?: string;
  organization?: string;
  type?: string;
  fullName?: string;
  registered_on?: string;
  last_login?: string | null;
}

export interface ExternalUserPayload {
  person: Person;
  email: string;
  organization: string;
  type: ExternalUserType;
  ciam_user_created: boolean;
  country?: number | string;
}

export interface ExternalUserColumnMeta {
  cellClassName?: string;
  headerClassName?: string;
}
